/**
 * Environment-based configuration loader
 * Automatically selects the correct configuration based on REACT_APP_ENV or NODE_ENV
 * 
 * This manager app uses corporate MSAL authentication only (no B2C).
 */

const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
const isA11yTest = process.env.REACT_APP_A11Y_TEST === 'true';

// Dynamic import based on environment
let config;
if (isA11yTest) {
    // Use test config for accessibility testing - bypasses auth, uses mock API
    config = require('./config.a11ytest');
} else if (env === 'production') {
    config = require('./config.prod');
} else if (env === 'uat') {
    config = require('./config.uat');
} else if (env === 'devnonprod') {
    config = require('./config.devnonprod');
} else {
    config = require('./config.local');
}

export const msalConfigCorporate = config.msalConfigCorporate;
export const loginRequest = config.loginRequest;
export const getLoginRequest = config.getLoginRequest;
export const apiConfig = config.apiConfig;
export const appConfig = config.appConfig;
export const isTestMode = config.isTestMode ?? false;

// Helper to clear auth state on logout
const AUTH_STATE_KEY = 'auth_state';

export const clearAuthState = (): void => {
    sessionStorage.removeItem(AUTH_STATE_KEY);
};

// Export environment info for debugging
export const environment = {
    isDevelopment: env === 'development',
    isDevNonProd: env === 'devnonprod',
    isUAT: env === 'uat',
    isProduction: env === 'production',
    env: env,
};
